import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash-es';

@Pipe({
  name: '_',
})
export class LodashPipe implements PipeTransform {
  transform(value: any, method: string, ...rest: any[]): any {
    return _[method](value, ...rest);
  }
}
